import { render, staticRenderFns } from "./UContent.vue?vue&type=template&id=0a1c76bf&"
import script from "./UContent.vue?vue&type=script&lang=ts&"
export * from "./UContent.vue?vue&type=script&lang=ts&"
import style0 from "./UContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports